import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';


class FormGroup extends React.Component {
    static propTypes = {
        cssClass: PropTypes.string,
        error: PropTypes.string,
        label: PropTypes.string,
        name: PropTypes.string.isRequired,
        onBlur: PropTypes.func,
        onChange: PropTypes.func,
        onKeyPress: PropTypes.func,
        touched: PropTypes.bool,
        type: PropTypes.string.isRequired,
        value: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
        ]),
        disabled: PropTypes.bool,
    };

    static defaultProps = {
        cssClass: null,
        error: '',
        label: null,
        onBlur: () => {},
        onChange: () => {},
        onKeyPress: () => {},
        touched: true,
        value: '',
        disabled: false,
    };

    render() {
        const touchedError = this.props.touched && this.props.error;
        const formGroupClasses = classnames('form-group', this.props.cssClass);
        const formControlClasses = classnames('form-control', {'is-invalid': touchedError});
        return (
            <div className={formGroupClasses}>
                {this.props.label ? <label htmlFor={this.props.name}>{this.props.label}</label> : null}
                <input
                    id={this.props.name}
                    name={this.props.name}
                    type={this.props.type}
                    className={formControlClasses}
                    value={this.props.value !== null ? this.props.value : ''}
                    onBlur={this.props.onBlur}
                    onChange={this.props.onChange}
                    onKeyPress={this.props.onKeyPress}
                    disabled={this.props.disabled}
                />
                {touchedError && <div className="invalid-feedback">{touchedError}</div>}
            </div>
        );
    }
}

export default FormGroup;



// WEBPACK FOOTER //
// ./src/components/FormGroup.js